export const FIELD_UNCONFIRMED_TYPE = 'FIELD_UNCONFIRMED';
export const ROW_UNCONFIRMED_TYPE = 'ROW_UNCONFIRMED';
export const LINE_MAY_BE_SWAPPED_TYPE = 'LINE_MAY_BE_SWAPPED';
export const LINE_ITEMS_MISSING_TYPE = 'LINE_ITEMS_MISSING';
export const LOCATION_UNMATCHED_TYPE = 'LOCATION_UNMATCHED';
export const DUPLICATE_PURCHASE_ORDER_TYPE = 'DUPLICATE_PURCHASE_ORDER';
